<template>
    <router-view v-resize-init="useThrottle(callTaskList)"/>
</template>

<script lang="ts" setup>
import { callTaskList } from "@/app/providers/directives/Resize/state"
import { useThrottle } from "@/shared/lib/utils"

const publicRoutes = ['/doc/', '/policy', '/auth', '/register'];

if (publicRoutes?.some?.(route => location?.href?.includes?.(route)) == false) {
    localStorage.setItem('location', location?.pathname + location?.search)
}

</script>

<style lang="scss">

#app {
    width: 100vw;
    height: 100vh;
    // overflow: hidden;
}

#modals {
    position: fixed;
    top: 0;
    left: 0;

    contain: layout;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    display: contents;
}
#modals:not(:empty):has(*) {
    z-index: 1000;
    > * {
        z-index: 1000;
    }
}

</style>
